import { BASE_API_URL } from "utils/constants";
import { downloadFileGet, get, post } from '../../utils/api';
import { DataResponse } from "services/response";
import { ArchivesModel } from 'pages/extensions/archives';

export type FileModel = {
  id: string,
  url: string,
  name: string,
  createTime: string
}

export type ArchiveDetailModel = Partial<{
  id: string,
  documentName: string,
  documentType: string,
  infoType: string,
  productRef: string,
  description: string,
  createTime: string,
  actived: boolean,
  departmentId: string,
  companyCode: string
  fileUrl: FileModel[]
}>

// ============ Khai báo phương thức =====================
export interface IDocumentArchiveServices {
  // danh sách KHO TÀI LIỆU
  getListDocumentArchive(data: object): Promise<DataResponse<Array<ArchivesModel>>>

  // create tài liệu
  createDocumentArchive(data: any): Promise<DataResponse<any>>
  // upload file list document archive
  uploadCreateDocumentArchive(data: any): Promise<DataResponse<any>>

  // edit tài liệu
  editDocumentArchive(data: any): Promise<DataResponse<any>>

  // get detail document archive  kho tài liệu
  getDetail(id?: string): Promise<DataResponse<ArchiveDetailModel>>
  // xóa kho tài liệu
  deleteArchive(id: string): Promise<DataResponse<any>>

  // lấy dropdown tên tài liệu
  getDropdownDocumentName(keywork?: string, actived?: boolean, companyCode?: string): Promise<DataResponse<any>>

  downloadFileExtensions(fileUrl: string): Promise<void>

}
// Hàm khởi tạo các phương thức của  service
export function createDocumentArchiveServices(): IDocumentArchiveServices {
  return {
    // danh sách KHO TÀI LIỆU
    getListDocumentArchive: async (data) => {
      return (await post(BASE_API_URL, `DocumentArchive/get-list-document-archive`, data)).data;
    },
    createDocumentArchive: async (data) => {
      return (await post(BASE_API_URL, `DocumentArchive/create-document-archive`, data)).data;
    },
    uploadCreateDocumentArchive: async (data) => {
      return (await post(BASE_API_URL, `DocumentArchive/upload-create-document-archive`, data)).data;
    },
    editDocumentArchive: async (data) => {
      return (await post(BASE_API_URL, `DocumentArchive/edit-document-archive`, data)).data;
    },

    getDetail: async (id) => {
      return (await get(BASE_API_URL, `DocumentArchive/get-document-archive/${id}`)).data;
    },
    deleteArchive: async (id) => {
      return (await get(BASE_API_URL, `DocumentArchive/delete-document-archive`, { Id: id })).data;
    },
    // lấy dropdown tên tài liệu
    getDropdownDocumentName: async (keyword, actived, companyCode) => {
      return (await get(BASE_API_URL, `Common/get-list-document`, { key: keyword, actived: actived, companyCode: companyCode })).data;
    },


    downloadFileExtensions: async (url) => {
      await downloadFileGet(`Extensions/download-file${url ? '?fileUrl=' + url : ''}`,);
    },
  };
}
